<template>
  <div>
      <Nav></Nav>
      <div>
        <img style="width:100%" src="../assets/images/course-banner.png" alt="">
        <img style="width:100%" src="../assets/images/course.jpg" alt="">
      </div>
      <Footer></Footer>
  </div>
</template>

<script>
import Nav from "@/components/topNav.vue";
import Footer from "@/components/footer.vue";
export default {
  components: {
    Nav,
    Footer,
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/course.vue